/* POOFS theme interactivity
   --------------------------------------------------------------
   Mobile menu, cart drawer, demo or Shopify cart, FAQ accordions.
   Set window.POOFS.useShopifyCart = true for real Shopify cart API.
*/
(function () {
  "use strict";

  var POOFS = (window.POOFS = window.POOFS || {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var PALETTE = {
    ZIP:   { color: "#DC2D7C", onInk: true },
    DOZE:  { color: "#F5A4C0", onInk: false },
    BLOOM: { color: "#87D04F", onInk: false },
    WOO:   { color: "#FF6BAA", onInk: false },
    OOPS:  { color: "#FFCC33", onInk: false },
    SHROOM:{ color: "#9B7BE5", onInk: false },
    IRON:  { color: "#C73448", onInk: true },
    DEWY:  { color: "#B82149", onInk: true },
    LUSH:  { color: "#F4D830", onInk: false }
  };

  function swatchFor(name) {
    var key = (name || "").toUpperCase().trim();
    return PALETTE[key] || { color: "#0E0D0B", onInk: true };
  }

  // ---- demo cart ------------------------------------------------------------
  var STORE_KEY = "poofs_cart_v1";
  function loadCart() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveCart(c) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(c)); } catch (e) {}
  }
  var cart = loadCart();
  var shopifyCart = null;

  function money(n) {
    return "$" + (Math.round(n * 100) / 100).toString().replace(/\.00$/, "");
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "$0";
    var amount = cents / 100;
    if (POOFS.moneyFormat && typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, POOFS.moneyFormat);
    }
    return money(amount);
  }

  function addItem(name, price, opts) {
    opts = opts || {};
    var key = (opts.key || name).toUpperCase();
    var found = null;
    for (var i = 0; i < cart.length; i++) { if (cart[i].key === key) { found = cart[i]; break; } }
    if (found) { found.qty += 1; }
    else {
      var sw = swatchFor(name);
      cart.push({
        key: key, name: name, price: price, qty: 1,
        color: opts.color || sw.color,
        onInk: opts.onInk != null ? opts.onInk : sw.onInk,
        chip: (opts.chip || name).toUpperCase().slice(0, 3)
      });
    }
    saveCart(cart);
    renderCart();
    openCart();
  }

  function changeQty(key, delta) {
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].key === key) {
        cart[i].qty += delta;
        if (cart[i].qty <= 0) cart.splice(i, 1);
        break;
      }
    }
    saveCart(cart);
    renderCart();
  }

  // ---- Shopify cart API -----------------------------------------------------
  function cartJsonUrl(path) {
    var base = (POOFS.routes && POOFS.routes.cart) ? POOFS.routes.cart.replace(/\/cart\/?$/, "") : "";
    return base + path;
  }

  function fetchShopifyCart() {
    return fetch(cartJsonUrl("/cart.js"), { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("Could not load cart");
        return r.json();
      })
      .then(function (data) {
        shopifyCart = data;
        return data;
      });
  }

  function addToShopifyCart(variantId, quantity, sellingPlanId) {
    var item = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (sellingPlanId) item.selling_plan = parseInt(sellingPlanId, 10);

    return fetch((POOFS.routes.cart_add || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          var msg = (body && (body.description || body.message)) || "Could not add to bag";
          throw new Error(msg);
        }
        return body;
      });
    }).then(function () {
      return fetchShopifyCart();
    });
  }

  function changeShopifyLine(lineKey, quantity) {
    return fetch((POOFS.routes.cart_change || "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error((body && body.description) || "Could not update cart");
        return body;
      });
    }).then(function () {
      return fetchShopifyCart();
    });
  }

  // ---- cart drawer rendering ------------------------------------------------
  function lineItemHTML(it) {
    var txt = it.onInk ? "var(--cream)" : "var(--ink)";
    return (
      '<div style="display:flex;align-items:center;gap:14px;padding:14px 0;border-bottom:1.5px dashed var(--ink);">' +
        '<div style="width:60px;height:60px;border-radius:12px;background:' + it.color + ';border:2px solid var(--ink);display:grid;place-items:center;color:' + txt + ';font-family:&quot;Archivo Black&quot;;font-size:18px;overflow:hidden;flex-shrink:0;">' +
          (it.image
            ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:cover;">'
            : it.chip) +
        '</div>' +
        '<div style="flex:1 1 0%;min-width:0;">' +
          '<div class="display" style="font-size:22px;">' + escapeHtml(it.name) + '</div>' +
          '<div class="mono" style="font-size:11px;letter-spacing:.1em;opacity:.7;">' +
            (it.priceLabel || money(it.price)) + ' · QTY ' + it.qty +
            (it.planLabel ? ' · ' + escapeHtml(it.planLabel) : '') +
          '</div>' +
        '</div>' +
        '<div style="display:flex;align-items:center;gap:6px;">' +
          '<button type="button" data-qty="-1" data-key="' + escapeAttr(it.key) + '" style="width:26px;height:26px;border-radius:999px;border:1.5px solid var(--ink);background:var(--cream);cursor:pointer;font-family:&quot;Archivo Black&quot;;font-size:14px;">−</button>' +
          '<span style="width:22px;text-align:center;font-weight:700;">' + it.qty + '</span>' +
          '<button type="button" data-qty="1" data-key="' + escapeAttr(it.key) + '" style="width:26px;height:26px;border-radius:999px;border:1.5px solid var(--ink);background:var(--cream);cursor:pointer;font-family:&quot;Archivo Black&quot;;font-size:14px;">+</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(s) {
    return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, "&#39;");
  }

  function shopifyItemsForRender() {
    if (!shopifyCart || !shopifyCart.items) return [];
    return shopifyCart.items.map(function (item) {
      var title = item.product_title || "Item";
      var sw = swatchFor(title.split(" ")[0]);
      return {
        key: item.key,
        name: title,
        price: item.final_price / 100,
        priceLabel: formatMoney(item.final_price),
        qty: item.quantity,
        color: sw.color,
        onInk: sw.onInk,
        chip: title.toUpperCase().slice(0, 3),
        image: item.image ? item.image : null,
        planLabel: item.selling_plan_allocation ? "Subscribe" : null
      };
    });
  }

  function renderCart() {
    var itemsEl = $("#poofs-cart-items");
    var emptyEl = $("#poofs-cart-empty");
    var subtotalEl = $("#poofs-subtotal");
    var count = 0;
    var subtotal = 0;
    var items = [];

    if (POOFS.useShopifyCart && shopifyCart) {
      items = shopifyItemsForRender();
      count = shopifyCart.item_count || 0;
      subtotal = (shopifyCart.total_price || 0) / 100;
    } else {
      cart.forEach(function (it) { count += it.qty; subtotal += it.qty * it.price; });
      items = cart;
    }

    if (itemsEl) {
      if (items.length) {
        itemsEl.style.display = "";
        itemsEl.innerHTML = items.map(lineItemHTML).join("");
        if (emptyEl) emptyEl.style.display = "none";
      } else {
        itemsEl.style.display = "none";
        itemsEl.innerHTML = "";
        if (emptyEl) emptyEl.style.display = "block";
      }
    }

    if (subtotalEl) {
      subtotalEl.textContent = POOFS.useShopifyCart && shopifyCart
        ? formatMoney(shopifyCart.total_price)
        : money(subtotal);
    }

    var badge = POOFS._cartBadge;
    if (badge) badge.textContent = String(count);
  }

  function openCart() {
    var d = $("#poofs-cart"), b = $("#poofs-cart-backdrop");
    if (d) d.style.transform = "translateX(0)";
    if (b) { b.style.opacity = "1"; b.style.pointerEvents = "auto"; }
  }

  function closeCart() {
    var d = $("#poofs-cart"), b = $("#poofs-cart-backdrop");
    if (d) d.style.transform = "translateX(110%)";
    if (b) { b.style.opacity = "0"; b.style.pointerEvents = "none"; }
  }

  function setMenu(open) {
    var m = $(".mobile-menu");
    if (m) m.setAttribute("data-open", open ? "true" : "false");
  }

  function priceFromText(t) {
    var m = (t || "").match(/\$\s*([\d.,]+)/);
    return m ? parseFloat(m[1].replace(/,/g, "")) : 0;
  }

  function nameFromCard(card) {
    if (!card) return null;
    var disp = $(".display", card);
    if (disp) return disp.textContent.trim().split("\n")[0].trim();
    return null;
  }

  // ---- PDP product JSON + variant selector ----------------------------------
  function getProductData() {
    var el = document.querySelector("[data-poofs-product-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariantData(productData, variantId) {
    if (!productData || !productData.variants) return null;
    var id = parseInt(variantId, 10);
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].id === id) return productData.variants[i];
    }
    return null;
  }

  function updateUrlVariant(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set("variant", String(variantId));
    window.history.replaceState({}, "", url.toString());
  }

  function applyPurchaseStyles(btn, active) {
    btn.classList.toggle("pdp-sub-option--active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  }

  function updateAddLabel(priceText) {
    var label = $("[data-poofs-add-label]");
    var btn = $("[data-poofs-add-to-cart]");
    if (!label || !btn || btn.disabled) return;
    label.textContent = "Add to bag · " + (priceText || "");
  }

  function updatePurchaseOptionPrices(variantData, productData) {
    if (!variantData) return;
    var buyBox = document.querySelector("[data-poofs-buy-box]");
    if (!buyBox) return;

    var onetimeBtn = buyBox.querySelector('[data-poofs-purchase-option="onetime"]');
    var subscribeBtn = buyBox.querySelector('[data-poofs-purchase-option="subscribe"]');
    var onetimeMoney = formatMoney(variantData.price);
    var subscribeCents = variantData.subscribePrice || 0;
    var hasSubscribe = productData && productData.showSubscription !== false &&
      productData.hasPlans && subscribeCents > 0 && subscribeBtn;

    if (onetimeBtn) {
      onetimeBtn.setAttribute("data-price", onetimeMoney);
      onetimeBtn.setAttribute("data-price-cents", String(variantData.price));
      var onetimePriceEl = onetimeBtn.querySelector(".pdp-sub-option__price");
      if (onetimePriceEl) onetimePriceEl.textContent = onetimeMoney;
      var onetimeDetail = onetimeBtn.querySelector(".pdp-sub-option__detail");
      if (onetimeDetail) onetimeDetail.textContent = onetimeMoney + " · ships once · no commitment";
    }

    if (subscribeBtn && hasSubscribe) {
      var subMoney = formatMoney(subscribeCents);
      subscribeBtn.setAttribute("data-price", subMoney);
      subscribeBtn.setAttribute("data-price-cents", String(subscribeCents));
      if (variantData.subscribePlanId) {
        subscribeBtn.setAttribute("data-selling-plan-id", String(variantData.subscribePlanId));
      }
      var subPriceEl = subscribeBtn.querySelector(".pdp-sub-option__price");
      if (subPriceEl) subPriceEl.textContent = subMoney;
    }

    var addBtn = buyBox.querySelector("[data-poofs-add-to-cart]");
    var active = buyBox.querySelector('[data-poofs-purchase-option][aria-pressed="true"]');
    if (addBtn && !addBtn.disabled && active) {
      updateAddLabel(active.getAttribute("data-price"));
    }
  }

  function setVariantAvailability(variantData) {
    var addBtn = document.querySelector("[data-poofs-add-to-cart]");
    var label = document.querySelector("[data-poofs-add-label]");
    if (!addBtn || !label) return;

    if (variantData && variantData.available) {
      addBtn.disabled = false;
      addBtn.removeAttribute("aria-disabled");
      addBtn.removeAttribute("data-sold-out");
    } else {
      addBtn.disabled = true;
      addBtn.setAttribute("aria-disabled", "true");
      addBtn.setAttribute("data-sold-out", "");
      label.textContent = "Sold out";
    }
  }

  function initVariantSelector() {
    var selector = document.querySelector("[data-poofs-variant-selector]");
    if (!selector) return;

    var productData = getProductData() || window.__POOFS_PRODUCT__;
    if (!productData) return;

    var form = $("#pdp-form");
    var variantInput = form && form.querySelector("[data-poofs-variant-id]");
    var heroPrice = document.querySelector("[data-poofs-hero-price]");
    var buttons = $$(".pdp-variant-btn", selector);

    function selectVariant(variantId) {
      if (!variantInput) return;
      variantInput.value = String(variantId);
      updateUrlVariant(variantId);

      var variantData = findVariantData(productData, variantId);
      if (variantData) {
        productData.variantId = variantData.id;
        productData.available = variantData.available;
        productData.onetimePrice = variantData.price;
        productData.subscribePrice = variantData.subscribePrice || 0;
        if (heroPrice) heroPrice.textContent = formatMoney(variantData.price);
        setVariantAvailability(variantData);
        updatePurchaseOptionPrices(variantData, productData);

        var subscribeBtn = document.querySelector('[data-poofs-purchase-option="subscribe"]');
        var onetimeBtn = document.querySelector('[data-poofs-purchase-option="onetime"]');
        if (
          subscribeBtn &&
          subscribeBtn.getAttribute("aria-pressed") === "true" &&
          (!variantData.subscribePrice || variantData.subscribePrice <= 0) &&
          onetimeBtn
        ) {
          onetimeBtn.click();
        }
      }

      buttons.forEach(function (btn) {
        var active = String(btn.getAttribute("data-variant-id")) === String(variantId);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        selectVariant(btn.getAttribute("data-variant-id"));
      });
    });
  }

  function initPdpGallery() {
    var gallery = document.querySelector("[data-poofs-gallery]");
    if (!gallery) return;

    var slides = $$(".pdp-gallery__slide", gallery);
    var thumbs = $$(".pdp-gallery__thumb", gallery);

    function activate(mediaId) {
      if (!mediaId) return;
      var id = String(mediaId);
      slides.forEach(function (s) {
        var match = s.getAttribute("data-media-id") === id;
        s.classList.toggle("is-active", match);
        if (match) s.removeAttribute("aria-hidden");
        else s.setAttribute("aria-hidden", "true");
        if (!match) {
          var v = s.querySelector("video");
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(function (t) {
        var match = t.getAttribute("data-media-id") === id;
        t.classList.toggle("is-active", match);
        t.setAttribute("aria-selected", match ? "true" : "false");
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        activate(t.getAttribute("data-media-id"));
      });
    });

    // Sync gallery to variant featured_media when variants change.
    var selector = document.querySelector("[data-poofs-variant-selector]");
    if (selector) {
      var productData = getProductData() || window.__POOFS_PRODUCT__;
      selector.addEventListener("click", function (e) {
        var btn = e.target.closest(".pdp-variant-btn");
        if (!btn || !productData) return;
        var variant = findVariantData(productData, btn.getAttribute("data-variant-id"));
        if (variant && variant.featured_media && variant.featured_media.id) {
          activate(variant.featured_media.id);
        }
      });
    }
  }

  function initPdpBuyBox() {
    var form = $("#pdp-form");
    if (!form) return;

    var productData = getProductData();
    if (productData) window.__POOFS_PRODUCT__ = productData;

    var qtyInput = form.querySelector("[data-poofs-quantity]");
    var planInput = form.querySelector("[data-poofs-selling-plan-input]");
    var errorEl = form.querySelector("[data-poofs-form-error]");
    var addBtn = form.querySelector("[data-poofs-add-to-cart]");
    var options = $$("[data-poofs-purchase-option]", form.closest("[data-poofs-buy-box]") || form);

    function getSelectedOption() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute("aria-pressed") === "true") return options[i];
      }
      return options[0] || null;
    }

    function selectOption(btn) {
      options.forEach(function (opt) {
        var isActive = opt === btn;
        applyPurchaseStyles(opt, isActive);
      });
      var mode = btn.getAttribute("data-poofs-purchase-option");
      if (planInput) {
        if (mode === "subscribe") {
          planInput.disabled = false;
          planInput.checked = true;
        } else {
          planInput.checked = false;
          planInput.disabled = true;
        }
      }
      updateAddLabel(btn.getAttribute("data-price"));
    }

    options.forEach(function (btn) {
      btn.addEventListener("click", function () {
        selectOption(btn);
      });
    });

    if (options.length) {
      var initial = options.find(function (b) { return b.getAttribute("aria-pressed") === "true"; }) || options[0];
      selectOption(initial);
    }

    var minus = form.querySelector("[data-poofs-qty-minus]");
    var plus = form.querySelector("[data-poofs-qty-plus]");
    if (qtyInput && minus) {
      minus.addEventListener("click", function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(Math.max(1, v - 1));
      });
    }
    if (qtyInput && plus) {
      plus.addEventListener("click", function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(v + 1);
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!POOFS.useShopifyCart) return;

      var variantEl = form.querySelector("[data-poofs-variant-id]");
      var variantId = variantEl && variantEl.value;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var selected = getSelectedOption();
      var sellingPlanId = null;
      if (selected && selected.getAttribute("data-poofs-purchase-option") === "subscribe") {
        sellingPlanId = selected.getAttribute("data-selling-plan-id") ||
          (planInput && planInput.value) || null;
      }

      if (!variantId) return;
      if (errorEl) { errorEl.style.display = "none"; errorEl.textContent = ""; }

      var originalHtml = addBtn ? addBtn.innerHTML : "";
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.innerHTML = '<span data-poofs-add-label>Adding…</span><span class="arr">→</span>';
      }

      addToShopifyCart(variantId, qty, sellingPlanId)
        .then(function () {
          renderCart();
          openCart();
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message || "Could not add to bag";
            errorEl.style.display = "block";
          }
        })
        .finally(function () {
          if (addBtn && !addBtn.hasAttribute("data-sold-out")) {
            addBtn.disabled = false;
            addBtn.innerHTML = originalHtml;
            var sel = getSelectedOption();
            if (sel) updateAddLabel(sel.getAttribute("data-price"));
          }
        });
    });
  }

  // ---- quick add to cart (home lineup cards) --------------------------------
  function initQuickAdd() {
    $$("[data-poofs-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation(); // card may be wrapped in a product link
        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;

        // Demo cart fallback when the Shopify AJAX cart is disabled.
        if (!POOFS.useShopifyCart) {
          var amt = parseFloat(btn.getAttribute("data-price-amount")) || 0;
          addItem(btn.getAttribute("data-name") || "STRIP", amt, {});
          return;
        }

        var original = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = "Adding…";

        addToShopifyCart(variantId, 1)
          .then(function () {
            renderCart();
            openCart();
            btn.innerHTML = "Added ✓";
            setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400);
          })
          .catch(function (err) {
            btn.innerHTML = (err && err.message) || "Sold out";
            setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 2000);
          });
      });
    });
  }

  // ---- bundle builder -------------------------------------------------------
  function addItemsToShopifyCart(items) {
    return fetch((POOFS.routes.cart_add || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          var msg = (body && (body.description || body.message)) || "Could not add your stack";
          throw new Error(msg);
        }
        return body;
      });
    }).then(function () {
      return fetchShopifyCart();
    });
  }

  function initBundleBuilder() {
    var root = $("[data-bundle]");
    if (!root) return;

    var stackEl = $("[data-bundle-stack]", root);
    var addBtn = $("[data-bundle-add]", root);
    var emptyHint = stackEl ? stackEl.getAttribute("data-empty") : "";
    var ctaLabel = addBtn ? addBtn.getAttribute("data-label") : "Add my stack";
    var rows = {};

    function selected() {
      var out = [];
      Object.keys(rows).forEach(function (k) { if (rows[k]) out.push(rows[k]); });
      return out;
    }

    function fmt(cents) {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney && POOFS.moneyFormat) {
        return Shopify.formatMoney(cents, POOFS.moneyFormat);
      }
      return money(cents / 100);
    }

    function pill(d) {
      var inner = '<div style="display:flex;align-items:center;justify-content:center;gap:10px;background:' + d.accent +
        ';color:' + d.text + ';border:2px solid var(--ink);border-radius:16px;padding:12px 16px;min-width:0;">' +
        '<div style="min-width:0;">' +
          '<div class="display" style="font-size:clamp(22px,2.6vw,30px);line-height:.9;font-family:&quot;Archivo Black&quot;;">' + escapeHtml(d.code) + '</div>' +
          (d.category ? '<div class="mono" style="font-size:10px;letter-spacing:.1em;margin-top:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(d.category) + '</div>' : '') +
        '</div>' +
      '</div>';
      if (d.url) {
        return '<a href="' + escapeAttr(d.url) + '" style="text-decoration:none;color:inherit;display:block;" aria-label="' + escapeAttr(d.code) + '">' + inner + '</a>';
      }
      return inner;
    }

    function render() {
      var sel = selected();
      if (stackEl) {
        if (!sel.length) {
          stackEl.innerHTML = '<div style="font-size:14px;opacity:.6;">' + escapeHtml(emptyHint) + '</div>';
        } else {
          stackEl.innerHTML = sel.map(function (o) { return pill(o.dataset); }).join("");
        }
      }
      if (addBtn) {
        if (!sel.length) {
          addBtn.disabled = true;
          addBtn.style.opacity = "0.5";
          addBtn.innerHTML = escapeHtml(ctaLabel) + ' <span class="arr">→</span>';
        } else {
          var total = 0;
          sel.forEach(function (o) { total += parseInt(o.getAttribute("data-price-cents"), 10) || 0; });
          addBtn.disabled = false;
          addBtn.style.opacity = "1";
          addBtn.innerHTML = escapeHtml(ctaLabel) + ' — ' + fmt(total) + ' <span class="arr">→</span>';
        }
      }
    }

    function setActive(b, on) {
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.style.background = on ? b.getAttribute("data-accent") : "var(--cream)";
      b.style.color = on ? b.getAttribute("data-text") : "var(--ink)";
      b.style.transform = on ? "scale(1.04)" : "scale(1)";
    }

    $$("[data-bundle-row]", root).forEach(function (rowEl) {
      var rowId = rowEl.getAttribute("data-bundle-row");
      rows[rowId] = null;
      var opts = $$("[data-bundle-option]", rowEl);
      opts.forEach(function (opt) {
        opt.addEventListener("click", function () {
          var wasSelected = rows[rowId] === opt;
          opts.forEach(function (b) { setActive(b, false); });
          if (wasSelected) {
            rows[rowId] = null;
          } else {
            setActive(opt, true);
            rows[rowId] = opt;
          }
          render();
        });
      });
    });

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var sel = selected();
        if (!sel.length) return;

        if (!POOFS.useShopifyCart) {
          sel.forEach(function (o) {
            var cents = parseInt(o.getAttribute("data-price-cents"), 10) || 0;
            addItem(o.getAttribute("data-code") || "STRIP", cents / 100, {});
          });
          return;
        }

        var items = [];
        sel.forEach(function (o) {
          var id = parseInt(o.getAttribute("data-variant-id"), 10);
          if (id) items.push({ id: id, quantity: 1 });
        });
        if (!items.length) return;

        addBtn.disabled = true;
        addBtn.innerHTML = "Adding…";
        addItemsToShopifyCart(items)
          .then(function () {
            renderCart();
            openCart();
            addBtn.innerHTML = "Added ✓";
            setTimeout(render, 1400);
          })
          .catch(function (err) {
            addBtn.innerHTML = (err && err.message) || "Try again";
            setTimeout(render, 2200);
          });
      });
    }

    render();
  }

  // ---- home hero product swatches -------------------------------------------
  function initHero() {
    var hero = $("[data-hero]");
    if (!hero) return;

    var card = $("[data-hero-card]", hero);
    var eyebrow = $("[data-hero-eyebrow]", hero);
    var code = $("[data-hero-code]", hero);
    var img = $("[data-hero-img]", hero);
    var tagline = $("[data-hero-tagline]", hero);
    var body = $("[data-hero-body]", hero);
    var meta = $("[data-hero-meta]", hero);
    var price = $("[data-hero-price]", hero);
    var highlight = $("[data-hero-highlight]", hero);
    var swatches = $$("[data-hero-swatch]", hero);
    if (!swatches.length) return;

    function select(index) {
      var src = null;
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].getAttribute("data-index") === index) { src = swatches[i]; break; }
      }
      if (!src) return;
      var d = src.dataset;

      if (card) { card.style.background = d.accent; card.style.color = d.text; }
      if (highlight) {
        highlight.textContent = d.label || "";
        highlight.style.background = d.accent;
        highlight.style.color = d.text;
      }
      if (eyebrow) eyebrow.textContent = "POOFS · " + (d.indexLabel || "") + " · " + (d.label || "");
      if (tagline) tagline.textContent = d.tagline || "";
      if (meta) meta.textContent = d.meta || "";
      if (price) price.textContent = d.price || "";

      if (body) body.setAttribute("data-mode", d.img ? "image" : "text");
      if (img && code) {
        if (d.img) {
          img.src = d.img;
          img.style.display = "";
          code.style.display = "none";
        } else {
          img.removeAttribute("src");
          img.style.display = "none";
          code.textContent = d.code || "";
          // Font size scales off --chars so long codes (SHROOM) still fit the card.
          code.style.setProperty("--chars", Math.max(3, (d.code || "").length));
          code.style.display = "";
        }
      }

      swatches.forEach(function (s) {
        var on = s.getAttribute("data-index") === index;
        // Only the round dots carry the selected ring; floaty buttons keep their
        // ring-positioning transform untouched.
        if (s.classList.contains("hero-swatch--dot")) {
          s.style.transform = on ? "scale(1.15)" : "scale(1)";
          s.style.boxShadow = on
            ? "0 0 0 3px var(--cream), 0 0 0 5px var(--ink)"
            : "none";
        }
        s.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    swatches.forEach(function (s) {
      s.addEventListener("click", function () {
        select(s.getAttribute("data-index"));
      });
    });
  }

  // ---- wire on load ---------------------------------------------------------
  function init() {
    // Track cart count badge for live updates, but DON'T hijack the cart link —
    // let installed slide-cart apps intercept the click on the /cart anchor.
    var badge = document.querySelector(".cart-link .cart-count");
    if (badge) POOFS._cartBadge = badge;

    // External callers can trigger a refresh + open after adding via /cart/add.js
    document.addEventListener("poofs:cart:updated", function () {
      if (POOFS.useShopifyCart) {
        fetchShopifyCart().then(renderCart).then(openCart).catch(function () { openCart(); });
      } else {
        renderCart();
        openCart();
      }
    });
    POOFS.openCart = openCart;
    POOFS.refreshCart = function () {
      return POOFS.useShopifyCart
        ? fetchShopifyCart().then(renderCart)
        : Promise.resolve(renderCart());
    };
    $$("[data-poofs-cart-close]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); closeCart(); });
    });
    var backdrop = $("#poofs-cart-backdrop");
    if (backdrop) backdrop.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeCart(); setMenu(false); }
    });

    var itemsEl = $("#poofs-cart-items");
    if (itemsEl) {
      itemsEl.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-qty]");
        if (!btn) return;
        var key = btn.getAttribute("data-key");
        var delta = parseInt(btn.getAttribute("data-qty"), 10);

        if (POOFS.useShopifyCart && shopifyCart) {
          var line = null;
          for (var i = 0; i < shopifyCart.items.length; i++) {
            if (shopifyCart.items[i].key === key) { line = shopifyCart.items[i]; break; }
          }
          if (!line) return;
          var newQty = line.quantity + delta;
          changeShopifyLine(key, newQty).then(renderCart).catch(function () {});
          return;
        }

        changeQty(key, delta);
      });
    }

    var checkout = $("#poofs-checkout");
    if (checkout) {
      checkout.addEventListener("click", function () {
        if (POOFS.routes && POOFS.routes.cart) {
          window.location.href = POOFS.routes.cart;
        }
      });
    }

    $$(".menu-btn").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); setMenu(true); });
    });
    var mm = $(".mobile-menu");
    if (mm) {
      var closeBtn = mm.querySelector("button");
      if (closeBtn) closeBtn.addEventListener("click", function () { setMenu(false); });
      $$("a", mm).forEach(function (a) { a.addEventListener("click", function () { setMenu(false); }); });
    }

    if (!POOFS.useShopifyCart) {
      $$("button").forEach(function (b) {
        if (b.closest("[data-poofs-buy-box]") || b.hasAttribute("data-poofs-add-to-cart") || b.hasAttribute("data-poofs-quick-add")) return;
        var label = (b.textContent || "").trim();
        if (!/^add\b/i.test(label)) return;
        b.addEventListener("click", function (e) {
          e.preventDefault();
          var price = priceFromText(label);
          var isBundle = /bundle/i.test(label);
          var card = b.closest(".lift") || b.closest("[data-product-card]") || b.closest("section");
          var name = nameFromCard(card) || (isBundle ? "BUNDLE" : "STRIP");
          addItem(name, price, isBundle ? { color: "#0E0D0B", onInk: true, chip: name } : {});
        });
      });
    }

    $$('a[href^="/#"], a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var hash = a.getAttribute("href").replace(/^\/?/, "");
        if (hash.charAt(0) !== "#") hash = "#" + hash.split("#")[1];
        var target = hash.length > 1 ? document.getElementById(hash.slice(1)) : null;
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          setMenu(false);
        }
      });
    });

    $$("[data-faq-q]").forEach(function (q) {
      q.style.cursor = "pointer";
      q.addEventListener("click", function () {
        var ans = q.nextElementSibling;
        if (!ans) return;
        var hidden = window.getComputedStyle(ans).display === "none";
        ans.style.display = hidden ? "" : "none";
        var ind = q.querySelector("span:last-child") || q.lastElementChild;
        if (ind) ind.textContent = hidden ? "×" : "+";
      });
    });

    initPdpBuyBox();
    initVariantSelector();
    initPdpGallery();
    initHero();
    initQuickAdd();
    initBundleBuilder();

    if (POOFS.useShopifyCart) {
      fetchShopifyCart().then(renderCart).catch(function () { renderCart(); });
    } else {
      renderCart();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
